
import ArticleInfoBaseTemplate from './ArticleInfoBaseTemplate';
import ArticleInfoTags from '@root/views/article/components/info/ArticleInfoTags.vue';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoTags,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html
        ? this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '')
        : this.$props.article.content.title.text;
    },
    commentsNoBrackets() {
      const { commentsNoBrackets } = this.$channelConfig('settings');
      return commentsNoBrackets;
    },
  },
});
